import moment from 'moment/moment';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';
import { ConfigServer } from '../../data/config';
import { cedimi, sharp } from '../../constant/globalConstantsTypeClients';


export const useInformedConsent = () => {

    const [createSweet] = useSweetAlert();
    const history = useHistory();

    const [searchNim, setSearchNim] = useState("");
    const [date_ini, setDate_ini] = useState("");
    const [date_end, setDate_end] = useState("");

    const [filters, setFilters] = useState(true);
    const [loadingFilters, setLoadingFilters] = useState(false);
    const [listInformedConsent, setListInformedConsent] = useState([]);

    // ? PREVIEW
    const [loadingPreviewId, setLoadingPreviewId] = useState(null);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
    const [showPreview, setShowPreview] = useState(false);
    const [loadingDownloadId, setLoadingDownloadId] = useState(null);

    const url_helen = localStorage.getItem("url_helen");

    useEffect(() => {
        getInformedConsent()
    }, [])


    const handleChangeValue = (e, nameInput = "") => {

        if (nameInput !== '' && nameInput === "date_ini") {
            setDate_ini(e);
        }

        else if (nameInput !== '' && nameInput === "date_end") {
            setDate_end(e);
        }

        else if (e.target.name === "searchNim") {
            setSearchNim(e.target.value);
        }
    }

    const handleFilter = () => {
        let dateIni = "";
        let dateEnd = "";

        if (date_ini._d !== undefined) {
            dateIni = moment(date_ini).format("YYYY-MM-DD");
        }

        if (date_end._d !== undefined) {
            dateEnd = moment(date_end).format("YYYY-MM-DD");
        }

        getInformedConsent(searchNim, dateIni, dateEnd);
    }

    const getInformedConsent = async (nim = "", date1 = "", date2 = "") => {
        let requestOptions = {
            method: 'GET'
        };

        let listIc = [];

        let alternativeUrl = "";

        if (date1 !== "" && date2 !== "") {
            if (nim !== "") {
                alternativeUrl = "?date_ini=" + date1 + "&date_end=" + date2 + "&nim=" + nim;
            }
            else {
                alternativeUrl = "?date_ini=" + date1 + "&date_end=" + date2;
            }
        }
        else if (nim !== "") {
            alternativeUrl = "?nim=" + nim;
        }
            const isSpecialClient = [cedimi, sharp].includes(url_helen);

            const endpoint = isSpecialClient
                ? "Sample/ListPatientCISample"
                : "Sample/ListPatientCISampleSurvey";

            const respuesta = await sendRequest(
                requestOptions,
                `${endpoint}${alternativeUrl}`
            );
        if (respuesta.code === 200) {
            setListInformedConsent(respuesta.data);
            if (respuesta.data.length > 0) {

                setListInformedConsent(respuesta.data);


            }
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, getInformedConsent);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Consentimiento informado", "Ocurrio un error en el servidor");
        }
        else {
            createSweet("error", "warning", "Consentimiento informado", respuesta.data.msg);
        }
    }

        
    const handleOpenPreview = async (nim) => {

        setLoadingPreviewId(nim);

        try {


            const token = localStorage.getItem("token");

            const isSpecialClient = [cedimi, sharp].includes(url_helen);

            const endpoint = isSpecialClient
                ? `/api/Sample/DownloadCi/${nim}`
                : `/api/TemplateConfigurationSurvey/GetAnswersPdf/${nim}`;

            const response = await fetch(
                ConfigServer.serverUrl + endpoint,
                {
                    method: 'GET',
                    headers: {
                        "Authorization": "Bearer " + token,
                        "Content-Type": "application/json"
                    }
                });

            if (!response.ok) {
                createSweet("warning", "warning", "No se pudo generar el PDF");
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            setPdfPreviewUrl(url);
            setShowPreview(true);

        } catch (error) {
            console.error("Error al generar el PDF:", error);
            createSweet("error", "error", "Ocurrió un error al generar el PDF");

        } finally {
            setLoadingPreviewId(null);
        }
    };


    const printPdfConsentInformed = async (nim = 0) => {

        setLoadingDownloadId(nim);
        try {
            const token = localStorage.getItem("token");

            const isSpecialClient = [cedimi, sharp].includes(url_helen);

            const endpoint = isSpecialClient
                ? `/api/Sample/DownloadCi/${nim}`
                : `/api/TemplateConfigurationSurvey/GetAnswersPdf/${nim}`;

            const response = await fetch(
                ConfigServer.serverUrl + endpoint,
                {
                    method: 'GET',
                    headers: {
                        "Authorization": "Bearer " + token,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (!response.ok) {
                createSweet("warning", "warning", "No se descargó el PDF");
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `consentimiento_informado_${nim}.pdf`);
            document.body.appendChild(link);
            link.style.display = 'none';
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al descargar el PDF:", error);
            createSweet("error", "error", "Ocurrió un error al descargar el PDF");

        } finally {
            setLoadingDownloadId(null);
        }
    }





    return {
        filters, setFilters, loadingFilters,
        searchNim, date_ini, date_end,
        handleChangeValue,
        handleFilter,
        listInformedConsent,
        printPdfConsentInformed,
        loadingPreviewId, pdfPreviewUrl, showPreview, handleOpenPreview, setShowPreview, loadingDownloadId

    }
}
